import Link from 'next/link';
import BadgeCounter from '../../../../ui-kit/BadgeCounter/BadgeCounter';
import { useExtNcUnreadCountsService } from '../../../../../modules/external-natification-center';
import { useAppConfig } from '../../../../../utils/appConfig/useAppConfig';


const HeaderNotificationsButton = () => {
  const { unreadTotal } = useExtNcUnreadCountsService();
  const { fetchConfig: { language }} = useAppConfig();

  return (
    <Link
      href={`/${language}/nc/orders`}
      data-marker="Header Notifications Button"
    >
    <span className="HeaderNotificationsButton">
      <i className="HeaderNotificationsButton__icon icon icon-bell-full"></i>

      {
        !!unreadTotal && (
          <div
            className="HeaderNotificationsButton__count"
            data-marker="Header Notifications Count"
          >
            <BadgeCounter count={unreadTotal} dataMarker="Header Notifications Count"/>
          </div>
        )
      }

      <style jsx>{`
        .HeaderNotificationsButton {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          margin-right: 16px;
        }

        .HeaderNotificationsButton__icon {
          color: var(--colors-brandLightGrey8);
          font-size: 15px;
          transition: all 0.3s;
        }

        .HeaderNotificationsButton:hover .HeaderNotificationsButton__icon {
          color: var(--colors-doveGray);
        }

        .HeaderNotificationsButton__count {
          position: absolute;
          top: -7px;
          left: 8px;
        }
      `}</style>
    </span>
    </Link>
  );
};

export default HeaderNotificationsButton;
